import React, { useEffect, useMemo, useState ,useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Box,
  Alert,
  Paper,
  Stack,
  Typography,
  IconButton,
  Chip,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PetsOutlinedIcon from "@mui/icons-material/PetsOutlined";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PrintIcon from "@mui/icons-material/Print";
import DescriptionIcon from "@mui/icons-material/Description";
import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import ThermostatOutlinedIcon from "@mui/icons-material/ThermostatOutlined";
import AgricultureOutlinedIcon from "@mui/icons-material/AgricultureOutlined";
import HeartBrokenOutlinedIcon from "@mui/icons-material/HeartBrokenOutlined";
import MonitorWeightOutlinedIcon from "@mui/icons-material/MonitorWeightOutlined";
import Autocomplete from "@mui/material/Autocomplete";
import {  useNavigate } from "react-router-dom";

import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";

import Kpi from "../components/donem-detay/Kpi";
import SensorCharts from "../components/donem-detay/SensorCharts";
import DetailCards from "../components/donem-detay/detayCard";
import Kameralar from "../components/donem-detay/Kameralar";
import {
  grafiklerService,
  getKumesKartiHindiBilgileri,
  getKumesKartiBilgileri,
  getStokYemTipleri,
  getYemFabrikalariByKumes,
  addSuTuketimi,
  addKilo,
  addEntDeath,
  addDeath,
  postEntBaitAdd,
  postBaitAdd,
  getYemStokTavuk,
  getYemStokDisiHindi,
  getYemStokErkekHindi,
  getSuTuketimi,
  updateSuTuketimi,
} from "../services/api";
import { getBakiciInfo } from "../services/api";

const ORANGE = "#FF7A2B";
const ORANGE_HOVER = "#E66A20";
const BG = "#EEF2F7";



const normalizeRows = (list = []) =>
  list.map((r, idx) => ({
    id: r.ID ?? r.GUN ?? r.TARIH_STR ?? idx,
    donemId: r.DONEM_ID,
    kumesId: r.KUMES_ID,
    tarihStr: r.TARIH_STR,
    gun: r.GUN,
    aktifGunMu: r.AKTIF_GUN_MU,
    raw: r,
  }));

const getLatestIndex = (arr) => {
  if (!arr.length) return 0;
  let maxIdx = 0;
  let maxGun = Number.NEGATIVE_INFINITY;

  arr.forEach((x, i) => {
    const g = Number(x.gun ?? x.raw?.GUN);
    if (!Number.isNaN(g) && g > maxGun) {
      maxGun = g;
      maxIdx = i;
    }
  });

  return maxIdx;
};

const getStartDay = (arr) => {
  if (!arr.length) return null;
  let minIdx = 0;
  let minGun = Number.POSITIVE_INFINITY;
  arr.forEach((x, i) => {
    const g = Number(x.gun ?? x.raw?.GUN);
    if (!Number.isNaN(g) && g < minGun) {
      minGun = g;
      minIdx = i;
    }
  });
  return arr[minIdx] || null;
};

const pctChange = (curr, prev) => {
  const c = Number(curr);
  const p = Number(prev);
  if (Number.isNaN(c) || Number.isNaN(p) || p === 0) return null;
  return ((c - p) / p) * 100;
};

const toLocalDateTimeInput = (d = new Date()) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const parseTrDate = (tr) => {
  if (!tr) return null;
  const [d, m, y] = tr.split(".");
  if (!d || !m || !y) return null;
  return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
};

const withCurrentDateTime = (trDate) => {
  const isoDate = parseTrDate(trDate);
  if (!isoDate) return toLocalDateTimeInput();
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${isoDate}T${pad(now.getHours())}:${pad(now.getMinutes())}`;
};

const toTarihGun = (tr) => {
  const iso = parseTrDate(tr);
  if (!iso) return null;
  return Number(iso.replaceAll("-", ""));
};

const toApiDateTR = (datetimeLocalStr) => {
  // "2026-02-22T22:03" -> "2026-02-22T22:03:00.000+03:00"
  if (!datetimeLocalStr) return null;
  return `${datetimeLocalStr}:00.000+03:00`;
};

// ✅ TR format dönüştürücüler
const formatDateToTr = (isoDate) => {
  if (!isoDate) return "";
  const [y, m, d] = isoDate.split("-");
  if (!y || !m || !d) return "";
  return `${d.padStart(2, "0")}.${m.padStart(2, "0")}.${y}`;
};

const getCurrentTime = () => {
  const pad = (n) => String(n).padStart(2, "0");
  const now = new Date();
  return `${pad(now.getHours())}:${pad(now.getMinutes())}`;
};

export default function DonemDetayPage({}) {
const navigate = useNavigate();


  const { kumesId, donemId } = useParams();
  const { state } = useLocation();
  const hayvanCinsId = state?.hayvanCinsId ?? state?.initialData?.HAYVAN_CINS_ID;
  const isIntegrated = !!state?.isIntegrated;
  const initialData = state?.initialData || null;
const viewMode = state?.viewMode || "active";
const isAktifDonem = initialData?.URETIM_KAPANDI_MI === "H";
// console.log("state ve initialData:", state, initialData);
const canEdit = state?.canEdit ?? isAktifDonem; 
// console.log(kumesId, donemId, hayvanCinsId, state);


  
  const [ureticiId, setUreticiId] = useState(null); // ✅ EKLE

  // ✅ URETICI_ID'yi getBakiciInfo'dan al
  useEffect(() => {
    const fetchUreticiId = async () => {
      try {
        const response = await getBakiciInfo();
        let bakiciBilgisi = response.data?.data || response.data || {};

        if (Array.isArray(bakiciBilgisi) && bakiciBilgisi.length > 0) {
          bakiciBilgisi = bakiciBilgisi[0];
        }

        const fetchedUreticiId = bakiciBilgisi?.URETICI_ID || null;
        setUreticiId(fetchedUreticiId);
        
        // console.log("✅ UreticiId getBakiciInfo'dan alındı:", fetchedUreticiId);
      } catch (err) {
        // console.error("❌ UreticiId alınamadı:", err);
      }
    };

    fetchUreticiId();
  }, []);

  const [rows, setRows] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [olumError, setOlumError] = useState("");
  const [suError, setSuError] = useState("");
  const [kiloError, setKiloError] = useState("");
  const [yemError, setYemError] = useState("");
  const [canliAgirlikError, setCanliAgirlikError] = useState("");
  const [bakiciError, setBakiciError] = useState("");
  const [takviyeError, setTakviyeError] = useState("");
  const [error, setError] = useState("");

  // ✅ REFRESH TRİGGER EKLE
  const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [suRefresh, setSuRefresh] = useState(0);
  const [kiloRefresh, setKiloRefresh] = useState(0);
  const [olumRefresh, setOlumRefresh] = useState(0);
  const [yemRefresh, setYemRefresh] = useState(0);
  const [ziyaretRefresh, setZiyaretRefresh] = useState(0);
  const [asilamaRefresh, setAsilamaRefresh] = useState(0);
  const [ilacRefresh, setIlacRefresh] = useState(0);

  // dialogs
  const [openSu, setOpenSu] = useState(false);
  const [openKilo, setOpenKilo] = useState(false);
  const [openOlum, setOpenOlum] = useState(false);
  const [openYem, setOpenYem] = useState(false);
  const [suEditOpen, setSuEditOpen] = useState(false);
  const [suEditData, setSuEditData] = useState(null);

  const [yemTipleri, setYemTipleri] = useState([]);
  const [yemFabrikalar, setYemFabrikalar] = useState([]);
  const [yemLoading, setYemLoading] = useState(false);
  const [yemStokList, setYemStokList] = useState([]);

  const [jumpOpen, setJumpOpen] = useState(false);
  const [jumpValue, setJumpValue] = useState("");


   // ✅ Loading state'leri
  const [suLoading, setSuLoading] = useState(false);
  const [kiloLoading, setKiloLoading] = useState(false);
  const [olumLoading, setOlumLoading] = useState(false);
  const [yemLoading2, setYemLoading2] = useState(false);
  const [suEditLoading, setSuEditLoading] = useState(false);

 const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });
  const showSnack = (message, severity = "success") =>
    setSnack({ open: true, message, severity });




  
  
  // ✅ Su, Kilo, Ölüm form state'leri
  const [suForm, setSuForm] = useState({
    VERI_ZAMAN: toLocalDateTimeInput(), // ✅ Şu anki tarih-saat
    SAYAC_DEGERI: "",
    SAYAC_DEGISTI: false,
  });

  const [kiloForm, setKiloForm] = useState({
    VERI_ZAMAN: "",
    GRAM: "",
  });

  useEffect(() => {
  if (!openKilo) return;

  // ✅ Dialog her açıldığında "şu an" tarihi bas
  setKiloForm((s) => ({
    ...s,
    VERI_ZAMAN: toLocalDateTimeInput(),
  }));
}, [openKilo]);

  const [olumForm, setOlumForm] = useState({
    OLUM_SAYISI: "",
    TARIH: "",
    SAAT: "",
  });

  const [yemForm, setYemForm] = useState({
    YEM_TIP_ID: "",
    YEM_FABRIKA_ID: "",
    ACIKLAMA: "",
    BIRIM_FIYAT: "",
    MIKTAR: "",
    KDV_ORAN: 0,
    TARIH: "",
    SAAT: "",
    siparisAcil: false,
  });


  const current = rows[selectedIndex];
  const startDay = getStartDay(rows);

  const infoCardSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  minWidth: 0,
};

const infoIconWrapSx = (bg, color) => ({
  width: 42,
  height: 42,
  minWidth: 42,
  borderRadius: 2.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: bg,
  color,
});

const headerLabelSx = {
  fontSize: 13,
  color: "#7C8AA5",
  fontWeight: 500,
  lineHeight: 1.1,
};

const headerValueSx = {
  fontSize: 17,
  color: "#0F172A",
  fontWeight: 800,
  lineHeight: 1.2,
};

const hayvanAdetFormatted =
  initialData?.SON_BITIS_SAYI != null
    ? `${Number(initialData.SON_BITIS_SAYI).toLocaleString("tr-TR")} Adet`
    : "-";

const donemAralikText =
  startDay?.tarihStr && current?.tarihStr
    ? `${startDay.tarihStr} - ${current.tarihStr}`
    : "-";

const goToDay = (value = jumpValue) => {
  const n = Number(String(value).replace(/[^\d]/g, ""));
  if (!rows?.length || Number.isNaN(n)) return;

  const idx = rows.findIndex((r) => Number(r.gun) === n);

  if (idx >= 0) {
    setSelectedIndex(idx);
    setJumpValue("");
  }
};


  const dayOptions = useMemo(() => {
  return (rows || []).map((r, idx) => ({
    index: idx,
    label: `Gün ${r?.gun ?? idx + 1} • ${r?.tarihStr ?? ""}`,
    gun: r?.gun ?? idx + 1,
  }));
}, [rows]);

const selectedOption = dayOptions[selectedIndex] || null;
useEffect(() => {
  if (selectedOption) {
    setJumpValue(selectedOption.label);
  }
}, [selectedOption]);

  const gunMap = useMemo(() => {
    const m = new Map();
    rows.forEach((r) => m.set(Number(r.gun), r));
    return m;
  }, [rows]);

  const prevRow = current ? gunMap.get(Number(current.gun) - 1) : null;

  useEffect(() => {
    if (!donemId || !hayvanCinsId) return;
    const controller = new AbortController();
    setLoading(true);
    setError("");

    const fetcher =
      hayvanCinsId === 2 ? getKumesKartiHindiBilgileri : getKumesKartiBilgileri;

    fetcher(donemId, { signal: controller.signal })
      .then((res) => {
        const list = res?.data?.data || [];
        const normalized = normalizeRows(list);
        setRows(normalized);
        setSelectedIndex(getLatestIndex(normalized));
      })
      .catch((err) => {
        if (err?.name === "CanceledError" || err?.message === "canceled") return;
        setError(err?.message || "Detay verisi alınamadı.");
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [donemId, hayvanCinsId, suRefresh, kiloRefresh, olumRefresh, yemRefresh, ziyaretRefresh, asilamaRefresh, ilacRefresh]);

  useEffect(() => {
    if (!openYem || !isIntegrated) return;

    const gunId = state?.initialData?.KACINCI_GUN;
    const sirketId = state?.initialData?.ENTEGRE_SIRKET_ID;
    const cinsiyetId = state?.initialData?.CINSIYET_ID;

    if (!gunId || !sirketId) return;

    setYemLoading(true);
    setYemError("");

    let serviceCall = null;

    if (hayvanCinsId === 1) {
      serviceCall = getYemStokTavuk(gunId, sirketId);
    } else if (hayvanCinsId === 2) {
      if (cinsiyetId === 1) {
        serviceCall = getYemStokErkekHindi(gunId, sirketId);
      } else if (cinsiyetId === 2) {
        serviceCall = getYemStokDisiHindi(gunId, sirketId);
      } else {
        setYemError("Hindi cinsiyeti 'Karışık' olduğu için stok seçilemedi.");
        setYemLoading(false);
        return;
      }
    }

    if (!serviceCall) {
      setYemLoading(false);
      return;
    }

    serviceCall
      .then((res) => {
        setYemStokList(Array.isArray(res?.data?.data) ? res.data.data : []);
      })
      .catch((err) => {
        setYemError(err?.response?.data?.message || err?.message || "Yem stok alınamadı.");
      })
      .finally(() => setYemLoading(false));
  }, [openYem, isIntegrated, hayvanCinsId, state?.initialData]);

  useEffect(() => {
    if (!openYem || isIntegrated) return;
    setYemLoading(true);
    Promise.all([getStokYemTipleri(kumesId), getYemFabrikalariByKumes(kumesId)])
      .then(([tipRes, fabRes]) => {
        setYemTipleri(Array.isArray(tipRes?.data?.data) ? tipRes.data.data : []);
        setYemFabrikalar(Array.isArray(fabRes?.data?.data) ? fabRes.data.data : []);
      })
      .finally(() => setYemLoading(false));
  }, [openYem, kumesId, isIntegrated]);

  const suOlan = current?.raw?.GUNLUK_SU_TUKETIM ?? "-";
  const suOlmasi = current?.raw?.HESAP_GUNLUK_SU_TUKETIM ?? "-";

  const isiOlan = current?.raw?.GUNLUK_ISI ?? "-";
  const isiOlmasi = current?.raw?.HESAP_GUNLUK_ISI ?? "-";

  const yemOlan = current?.raw?.GUNLUK_YEM_TUKETIM ?? "-";
  const yemOlmasi = current?.raw?.HESAP_GUNLUK_YEM_TUKETIM ?? "-";

  const olum = current?.raw?.GUNLUK_OLUM ?? "-";

  const agOlan = current?.raw?.ZIYARET_CANLI_AGIRLIK ?? "-";
  const agOlmasi = current?.raw?.CANLI_AGIRLIK ?? "-";

  const suDelta = pctChange(current?.raw?.GUNLUK_SU_TUKETIM, prevRow?.raw?.GUNLUK_SU_TUKETIM);
  const isiDelta = pctChange(current?.raw?.GUNLUK_ISI, prevRow?.raw?.GUNLUK_ISI);
  const yemDelta = pctChange(current?.raw?.GUNLUK_YEM_TUKETIM, prevRow?.raw?.GUNLUK_YEM_TUKETIM);
  const olumDelta = pctChange(current?.raw?.GUNLUK_OLUM, prevRow?.raw?.GUNLUK_OLUM);
  const agDelta = pctChange(current?.raw?.CANLI_AGIRLIK, prevRow?.raw?.CANLI_AGIRLIK);

const handleAddSu = async () => {
  try {
    setSuLoading(true);

    let veriZaman;
    if (suForm.VERI_ZAMAN) {
      const d = new Date(suForm.VERI_ZAMAN);
      veriZaman = d.toISOString();
    } else {
      veriZaman = new Date().toISOString();
    }

    const payload = {
      DONEM_ID: Number(donemId),
      VERI_ZAMAN: veriZaman,
      SAYAC_DEGERI: Number(suForm.SAYAC_DEGERI),
      SAYAC_DEGISTI: suForm.SAYAC_DEGISTI ? 1 : 0,
    };

    // console.log("📤 Su tüketim payload:", payload);

    await addSuTuketimi(payload);

    setOpenSu(false);
    setSuForm({
      VERI_ZAMAN: toLocalDateTimeInput(),
      SAYAC_DEGERI: "",
      SAYAC_DEGISTI: false,
    });
    setSuError("");
    setSuRefresh((prev) => prev + 1);
    showSnack("Su tüketimi kaydedildi ✓");
  } catch (err) {
    const errMsg = err?.response?.error?.data || err?.response?.data || err?.message;
    // console.error("❌ Su ekleme hatası:", errMsg);

    setSuError(typeof errMsg?.Error === "string" ? errMsg.Error : JSON.stringify(errMsg));
  } finally {
    setSuLoading(false);
  }
};

const handleAddKilo = async () => {
  try {
    setKiloLoading(true);
    setKiloError("");

    const payload = {
      DONEM_ID: Number(donemId),
      VERI_ZAMAN: toApiDateTR(kiloForm.VERI_ZAMAN), // ✅ TR -> API format
      GRAM: Number(kiloForm.GRAM),
    };

    // console.log("📤 Kilo payload:", payload);

    await addKilo(payload);

    setOpenKilo(false);
    setKiloForm({ VERI_ZAMAN: "", GRAM: "" }); // ✅ reset
    setKiloRefresh((prev) => prev + 1); // ✅ DetailCards yenilensin
    showSnack("Canlı ağırlık kaydedildi ✓");
  } catch (err) {
    const msg =
      err?.response?.data?.message ||
      err?.response?.data ||
      err?.message ||
      "Kilo eklenemedi";
    setKiloError(String(msg));
  } finally {
    setKiloLoading(false);
  }
};

const handleAddOlum = async () => {
  try {
    setOlumLoading(true);

    const payload = {
      DONEM_ID: Number(donemId),
      OLUM_SAYISI: Number(olumForm.OLUM_SAYISI),
      TARIH: olumForm.TARIH,
      SAAT: olumForm.SAAT,
    };

    // console.log("📤 Ölüm payload:", payload);

    if (isIntegrated) {
      await addEntDeath(payload);
    } else {
      await addDeath(payload);
    }

    setOpenOlum(false);
    setOlumForm({
      OLUM_SAYISI: "",
      TARIH: new Date().toISOString().split("T")[0],
      SAAT: getCurrentTime(),
    }); // ✅ reset
    setOlumError("");
    setOlumRefresh((prev) => prev + 1);
    showSnack("Ölüm kaydedildi ✓");
  } catch (err) {
    const errMsg = err?.response?.data?.Data || err?.response?.data?.Error || err?.message;
    // console.error("❌ Ölüm ekleme hatası:", errMsg);
    setOlumError(errMsg || "Ölüm eklenemedi");
  } finally {
    setOlumLoading(false);
  }
};

const handleAddYem = async () => {
  try {
    setYemLoading2(true);
    setYemError("");

    if (isIntegrated) {
      const stok = yemStokList[0];

      if (!stok) {
        setYemError("Yem stok bilgisi bulunamadı.");
        return;
      }

      // ✅ Zorunlu alan kontrolü
      if (!yemForm.MIKTAR || Number(yemForm.MIKTAR) <= 0) {
        setYemError("Sipariş miktarı zorunlu ve 0'dan büyük olmalıdır.");
        return;
      }

      if (!state?.initialData?.ENTEGRASYON_KODU) {
        setYemError("Entegrasyon kodu bulunamadı.");
        return;
      }

      if (!state?.initialData?.AKTIF_DONEM_PROJE_KODU) {
        setYemError("Proje numarası bulunamadı.");
        return;
      }

      // ✅ Tarih formatı: YYYY-MM-DD
      const tarihStr = new Date().toISOString().split("T")[0];

      const payload = {
        donemId: Number(donemId),
        entTanimYemStokKodId: stok.ENT_TANIM_YEM_STOK_KOD_ID,
        kumesKodu: state?.initialData?.ENTEGRASYON_KODU,
        projeNumarasi: state?.initialData?.AKTIF_DONEM_PROJE_KODU,
        siparisMiktari: Number(yemForm.MIKTAR),
        siparisTarihi: tarihStr,
        stokKodu: stok.STOK_KODU,
        siparisAcil: yemForm.siparisAcil ? 1 : 0,
      };

      // console.log("📤 Yem isteği payload:", payload);

      await postEntBaitAdd(payload);
    } else {
      // ✅ Entegresiz - Zorunlu alanlar
      if (!yemForm.YEM_TIP_ID) {
        setYemError("Yem Tipi seçiniz.");
        return;
      }
      if (!yemForm.YEM_FABRIKA_ID) {
        setYemError("Yem Fabrikası seçiniz.");
        return;
      }
      if (!yemForm.BIRIM_FIYAT || Number(yemForm.BIRIM_FIYAT) <= 0) {
        setYemError("Birim Fiyat zorunlu ve 0'dan büyük olmalıdır.");
        return;
      }
      if (!yemForm.MIKTAR || Number(yemForm.MIKTAR) <= 0) {
        setYemError("Miktar zorunlu ve 0'dan büyük olmalıdır.");
        return;
      }
      if (!yemForm.TARIH) {
        setYemError("Tarih seçiniz.");
        return;
      }

      const payload = {
        DONEM_ID: Number(donemId),
        YEM_TIP_ID: Number(yemForm.YEM_TIP_ID),
        YEM_FABRIKA_ID: Number(yemForm.YEM_FABRIKA_ID),
        ACIKLAMA: yemForm.ACIKLAMA || "",
        BIRIM_FIYAT: Number(yemForm.BIRIM_FIYAT),
        MIKTAR: Number(yemForm.MIKTAR),
        KDV_ORAN: 0,
        TARIH: formatDateToTr(yemForm.TARIH),
        SAAT: yemForm.SAAT || "00:00",
      };

      //  console.log("📤 Yem ekleme payload:", payload);

      await postBaitAdd(payload);
    }

    setOpenYem(false);
    setYemForm({
      YEM_TIP_ID: "",
      YEM_FABRIKA_ID: "",
      ACIKLAMA: "",
      BIRIM_FIYAT: "",
      MIKTAR: "",
      KDV_ORAN: 0,
      TARIH: "",
      SAAT: "",
      siparisAcil: false,
    });
    setYemError("");
    setYemRefresh((prev) => prev + 1);

    showSnack(isIntegrated ? "Yem siparişi verildi ✓" : "Yem kaydedildi ✓");
  } catch (e) {
    const msg =
      e?.response?.data?.Data ||
      e?.response?.data?.Error ||
      e?.response?.data?.message ||
      e?.message;

    // console.error("❌ Yem hatası:", msg);
    setYemError(msg || "Yem eklenemedi.");
  } finally {
    setYemLoading2(false);
  }
};

const handleUpdateSu = async () => {
  try {
    setSuEditLoading(true);

    await updateSuTuketimi({
      DONEM_SU_TUKETIM_ID: suEditData.DONEM_SU_TUKETIM_ID,
      SAYAC_DEGERI: Number(suEditData.SAYAC_DEGERI),
    });

    setSuEditOpen(false);
    setSuEditData(null);
    setSuRefresh((prev) => prev + 1);
    showSnack("Su verisi güncellendi ✓");
  } catch (err) {
    const msg = err?.response?.data?.message || err?.response?.data || "Su güncellenemedi";
    setSuError(msg);
    // console.error("❌ Su güncelleme hatası:", err?.response?.data);
  } finally {
    setSuEditLoading(false);
  }
};
  // gün değişince form tarihlerini güncelle
  useEffect(() => {
    if (!current?.tarihStr) return;
    const dateOnly = parseTrDate(current.tarihStr) || "";
    const dtLocal = withCurrentDateTime(current.tarihStr);
    const timeNow = getCurrentTime();

    setSuForm((s) => ({ ...s, VERI_ZAMAN: dtLocal }));
    setKiloForm((s) => ({ ...s, VERI_ZAMAN: dtLocal }));
    setOlumForm((s) => ({ ...s, TARIH: dateOnly, SAAT: timeNow }));
    setYemForm((s) => ({ ...s, TARIH: dateOnly, SAAT: timeNow }));
  }, [current?.tarihStr]);

  // ✅ grafik hook'ları EARLY RETURN'dan önce
  const [grafikTab, setGrafikTab] = useState("sicaklik");
  const [grafikDates, setGrafikDates] = useState([]);
  const [grafikTarihGun, setGrafikTarihGun] = useState(null);
  const [grafikData, setGrafikData] = useState([]);
  const [grafikLoading, setGrafikLoading] = useState(false);
  const [grafikError, setGrafikError] = useState("");


const stableGrafikData = useMemo(() => grafikData || [], [grafikData]);

const handleGrafikTabChange = useCallback((newTab) => {
  setGrafikTab(newTab);
}, []);


  // 1) Sadece tarihleri çek
  useEffect(() => {
    if (!donemId) return;
    setGrafikLoading(true);
    setGrafikError("");
    grafiklerService
      .getOlcumTarihleri(donemId)
      .then((res) => {
        setGrafikDates(Array.isArray(res?.data?.data) ? res.data.data : []);
      })
      .catch((err) => {
        setGrafikError(err?.message || "Ölçüm tarihleri alınamadı.");
      })
      .finally(() => setGrafikLoading(false));
  }, [donemId]);

  // 2) Seçili gün varsa onun TARIH_GUN’unu al, yoksa null
  useEffect(() => {
    if (!grafikDates.length) {
      setGrafikTarihGun(null);
      setGrafikData([]);
      return;
    }
    const currentGun = toTarihGun(current?.tarihStr);
    const match = grafikDates.find((x) => Number(x.TARIH_GUN) === Number(currentGun));

    if (match) {
      setGrafikTarihGun(Number(match.TARIH_GUN));
    } else {
      setGrafikTarihGun(null);
      setGrafikData([]);
    }
  }, [grafikDates, current?.tarihStr]);

  // 3) TARIH_GUN ile veri çek
  useEffect(() => {
    if (!donemId || !grafikTarihGun) return;
    setGrafikLoading(true);
    setGrafikError("");
    grafiklerService
      .getOlcumVerileri(donemId, grafikTarihGun)
      .then((res) => {
        setGrafikData(Array.isArray(res?.data?.data) ? res.data.data : []);
      })
      .catch((err) => {
        setGrafikError(err?.message || "Ölçüm verileri alınamadı.");
      })
      .finally(() => setGrafikLoading(false));
  }, [donemId, grafikTarihGun]);

  if (!hayvanCinsId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">Hayvan cinsi bilgisi yok.</Alert>
      </Box>
    );
  }

  return (
    
    <Box sx={{ p: { xs: 2, md: 3 }, minHeight: "100vh", bgcolor: BG }}>
  
      {/* ÜST PANEL  baş*/}
<Paper



  elevation={0}
  sx={{
    p: { xs: 1.25, md: 1.5 },
    borderRadius: 4,
    mb: 2,
    bgcolor: "#F8FAFC",
    border: "1px solid #E5E7EB",
  }}
>
  <Box
    sx={{
      p: { xs: 2, md: 3 },
      borderRadius: 3,
      bgcolor: "#FFFFFF",
      border: "1px solid #E5E7EB",
      boxShadow: "0 8px 24px rgba(15,23,42,0.04)",
    }}
  >
          <IconButton 
      onClick={() => navigate(-1)}
 sx={{ color: "#fff", bgcolor: "rgba(0,0,0,.15)", "&:hover": { bgcolor: "rgba(0,0,0,.25)" } }}
      >
              <ChevronLeftIcon sx={{ fontSize: 28 }} />
      </IconButton>
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", md: "center" }}
      spacing={{ xs: 2.5, md: 3 }}
    >
      {/* SOL TARAF */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: { xs: 24, md: 28 },
            fontWeight: 800,
            color: "#1E293B",
            mb: 2.5,
            letterSpacing: -0.4,
          }}
        >
          Üretim Dönemi Detayı
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 2, sm: 3, md: 4 }}
          useFlexGap
          flexWrap="wrap"
        >
          <Box sx={infoCardSx}>
            <Box sx={infoIconWrapSx("rgba(59,130,246,0.10)", "#2563EB")}>
              <PersonOutlineOutlinedIcon sx={{ fontSize: 24 }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={headerLabelSx}>Kümes Adı</Typography>
              <Typography sx={headerValueSx}>
                {state?.initialData?.kumesAdi || "Kümes Detay"}
              </Typography>
            </Box>
          </Box>

          <Box sx={infoCardSx}>
            <Box sx={infoIconWrapSx("rgba(59,130,246,0.10)", "#2563EB")}>
              <PersonOutlineOutlinedIcon sx={{ fontSize: 24 }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={headerLabelSx}>Dönem No</Typography>
              <Typography sx={headerValueSx}>
                {state?.initialData?.DONEM_NO || "Kümes Detay"}
              </Typography>
            </Box>
          </Box>

          <Box sx={infoCardSx}>
            <Box sx={infoIconWrapSx("rgba(34,197,94,0.10)", "#16A34A")}>
              <CalendarMonthOutlinedIcon sx={{ fontSize: 24 }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={headerLabelSx}>Kümes Dönemi </Typography>
              <Typography sx={headerValueSx}>
                {donemAralikText}
              </Typography>
            </Box>
          </Box>

          <Box sx={infoCardSx}>
            <Box sx={infoIconWrapSx("rgba(245,158,11,0.12)", "#D97706")}>
              <PetsOutlinedIcon sx={{ fontSize: 24 }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={headerLabelSx}>Canlı Hayvan</Typography>
              <Typography sx={headerValueSx}>
                {hayvanAdetFormatted}
              </Typography>
            </Box>
          </Box>




        </Stack>
      </Box>

      {/* SAĞ TARAF */}
      <Stack
            direction="column-reverse"
            alignItems="center"
            justifyContent="center"
            justifyItems="center"
            alignContent="center"
            spacing={1.5}
            sx={{
              flexShrink: 0,
              flexWrap: "nowrap",
            }}
          >
        <Autocomplete
          size="small"
          disableClearable
          options={dayOptions}
          noOptionsText=""
          value={selectedOption}
          onChange={(_, v) => {
            if (v) setSelectedIndex(v.index);

          }}
        getOptionLabel={(o) => (typeof o === "string" ? o : o?.label || "")}
        isOptionEqualToValue={(o, v) => o.index === v.index}
        popupIcon={<ChevronRightIcon sx={{ transform: "rotate(90deg)" }} />}

          sx={{
            width: 270,
            minWidth: 270,
            "& .MuiOutlinedInput-root": {
              height: 56,
              borderRadius: 2.5,
              bgcolor: "#FFFFFF",
              fontWeight: 800,
              color: "#0F172A",
              boxShadow: "0 2px 10px rgba(15,23,42,0.04)",
              "& fieldset": {
                borderColor: "#E5E7EB",
              },
              "&:hover fieldset": {
                borderColor: "#CBD5E1",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#2563EB",
                borderWidth: "1px",
              },
            },
            "& .MuiAutocomplete-input": {
              fontWeight: 700,
              color: "#111827",
            },
            "& .MuiAutocomplete-popupIndicator": {
              color: "#94A3B8",
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Gün seç"
            />
          )}
        />

        <Button 
          variant="contained"
          startIcon={<DescriptionIcon />}
          onClick={() =>
            navigate(`/kumes-karti/${donemId}`, {
              state: {
                hayvanCinsId,
                kumesId,
                donemId,
                initialData: state?.initialData,
              },
            })
          }
          sx={{
             width: 270,
            minWidth: 270,
            bgcolor: "#bebebe",
            color: "#fff",
            height: 56,
            borderRadius: 2.5,
            fontWeight: 800,
            fontSize: 15,
            textTransform: "none",
            whiteSpace: "nowrap",
            flexShrink: 0,
            boxShadow: "0 10px 24px rgba(255,122,43,0.22)",
            "&:hover": {
              bgcolor: "#E66A20",
            },
          }}
        >
          Kümes Kartı
        </Button>
      </Stack>
    </Stack>
  </Box>
</Paper>

      {/* ORTALI İÇERİK */}
      <Box sx={{ maxWidth: 1600, mx: "auto" }}>
        {/* KPI KARTLARI */}
       <Box
  sx={{
    display: "flex",
    gap: 2,
    flexDirection: { xs: "column", sm: "row" }, // telefon: alt alta, diğerleri: yan yana
    flexWrap: "nowrap",
    overflowX: { xs: "visible", sm: "auto" },  // telefon değilse sığmazsa kaydır
    pb: { sm: 1 },
    WebkitOverflowScrolling: "touch",
  }}
>
  {/* 1. Su Tüketimi - UZUN */}
  <Box sx={{ flex: { sm: "0 0 auto" } }}>
    <Kpi
      title="Su Tüketimi"
      icon={<WaterDropOutlinedIcon />}
      value={suOlmasi}
      unit="L"
      target={`${suOlan} L`}
      targetDelta={6.3}
      delta={suDelta}
      color="#3B82F6"
      onAction={() => setOpenSu(true)}
      size="short"
       disabled={!canEdit}
    />
  </Box>

  {/* 2. Sıcaklık - KISA */}
  <Box sx={{ flex: { sm: "0 0 auto" } }}>
    <Kpi
      title="Sıcaklık"
      icon={<ThermostatOutlinedIcon />}
      value={isiOlan}
      unit="°C"
      target={`${isiOlmasi} °C`}
      delta={isiDelta}
      color="#F59E0B"
      onAction={() => {}}
      size="short"
       disabled={true}
    />
  </Box>

  {/* 3. Yem Tüketimi - UZUN */}
  <Box sx={{ flex: { sm: "0 0 auto" } }}>
    <Kpi
      title="Yem Tüketimi"
      icon={<AgricultureOutlinedIcon />}
      value={yemOlmasi}
      unit="kg"
      target={`${yemOlan} kg`}
      delta={yemDelta}
      color="#22C55E"
      actionLabel={isIntegrated ? "İste" : "Ekle"}
      onAction={() => setOpenYem(true)}
      size="short"
       disabled={!canEdit}
    />
  </Box>

  {/* 4. Günlük Ölüm - KISA */}
  <Box sx={{ flex: { sm: "0 0 auto" } }}>
    <Kpi
      title="Günlük Ölüm"
      icon={<HeartBrokenOutlinedIcon />}
      value={olum}
      unit="adet"
      delta={olumDelta}
      color="#EF4444"
      showTarget={false}
      onAction={() => setOpenOlum(true)}
      size="short"
       disabled={!canEdit}
    />
  </Box>

  {/* 5. Canlı Ağırlık - UZUN */}
  <Box sx={{ flex: { sm: "0 0 auto" } }}>
    <Kpi
      title="Canlı Ağırlık"
      icon={<MonitorWeightOutlinedIcon />}
      value={agOlan}
      unit="kg"
      target={`${agOlmasi} kg`}
      targetDelta={4.3}
      delta={agDelta}
      color="#8B5CF6"
      onAction={() => setOpenKilo(true)}
      size="short"
       disabled={!canEdit}
    />
  </Box>
</Box>

        {/* GRAFİKLER */}
        <Box sx={{ mt: 3 }}>
        <SensorCharts
          data={stableGrafikData}
          tab={grafikTab}
          onTabChange={handleGrafikTabChange}
          loading={grafikLoading}
          error={grafikError}
        />
        </Box>

        {/* ✅ DETAY KARTLARI */}
        <DetailCards
          donemId={donemId}
          kumesId={kumesId}
          ureticiId={ureticiId} // ✅ Gönder
          isIntegrated={isIntegrated}
          refreshTrigger={refreshTrigger}
          onOpenSu={() => setOpenSu(true)}
          onOpenKilo={() => setOpenKilo(true)}
          onOpenOlum={() => setOpenOlum(true)}
          onOpenYem={() => setOpenYem(true)}
          onEditSu={(su) => { setSuEditData(su); setSuEditOpen(true); }}
          canEdit={canEdit}
          // ✅ Refresh counter'ları prop olarak geç
          olumRefresh={olumRefresh}
          suRefresh={suRefresh}
          yemRefresh={yemRefresh}
          kiloRefresh={kiloRefresh}
          ziyaretRefresh={ziyaretRefresh}
          asilamaRefresh={asilamaRefresh}
          ilacRefresh={ilacRefresh}
          // ✅ DetailCard'dan üst alanı güncellemek için callback'ler
          onOlumChanged={() => setOlumRefresh((p) => p + 1)}
          onSuChanged={() => setSuRefresh((p) => p + 1)}
          onYemChanged={() => setYemRefresh((p) => p + 1)}
          onKiloChanged={() => setKiloRefresh((p) => p + 1)}
          onZiyaretChanged={() => setZiyaretRefresh((p) => p + 1)}
          onAsilamaChanged={() => setAsilamaRefresh((p) => p + 1)}
          onIlacChanged={() => setIlacRefresh((p) => p + 1)}
        />
                {/* KAMERALAR */}
        <Box sx={{ mt: 3 }}>
          <Kameralar kumesId={kumesId} />
        </Box>
      </Box>

      {/* SU DIALOG */}
      <Dialog open={openSu} onClose={() => !suLoading && setOpenSu(false)} fullWidth maxWidth="sm">
        <DialogTitle>Su Tüketimi Ekle</DialogTitle>
        <DialogContent sx={{ pt: 2 }} style={{paddingTop:10}}>
          <Stack spacing={2}>
            {suError && <Alert severity="error">{suError}</Alert>}
            
           <TextField
               fullWidth
               size="medium"
                label="Veri Zaman"
               type="datetime-local"
               value={suForm.VERI_ZAMAN}
                  onChange={(e) => setSuForm({ ...suForm, VERI_ZAMAN: e.target.value })}
                  InputLabelProps={{
                  shrink: true,
                 sx: { fontSize: 14 },
                      }}
                   InputProps={{
                       sx: {
                      fontSize: 16,
                     "& .MuiInputBase-input": { py: 1.4 },
                          },
                             }}
                          helperText="Otomatik: Şu anki tarih-saat (İsterseniz değiştirebilirsiniz)"
                              />
            
            <TextField
              label="Sayaç Değeri (m³)"
              type="number"
              inputProps={{ step: "0.01", min: "0" }}
              value={suForm.SAYAC_DEGERI}
              onChange={(e) => setSuForm({ ...suForm, SAYAC_DEGERI: e.target.value })}
              placeholder="Örn: 150.5"
              autoFocus // ✅ İlk focus sayaç değerine
            />
            
            <FormControl fullWidth>
              <InputLabel>Sayaç Değişti Mi?</InputLabel>
              <Select
                value={suForm.SAYAC_DEGISTI ? "evet" : "hayir"}
                label="Sayaç Değişti Mi?"
                onChange={(e) =>
                  setSuForm({ ...suForm, SAYAC_DEGISTI: e.target.value === "evet" })
                }
              >
                <MenuItem value="hayir">❌ Hayır</MenuItem>
                <MenuItem value="evet">✅ Evet</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSu(false)} disabled={suLoading}>Vazgeç</Button>
          <Button variant="contained" onClick={handleAddSu} disabled={!canEdit || suLoading} sx={{ bgcolor: ORANGE }}
          startIcon={suLoading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
          >
            {suLoading ? "Kaydediliyor..." : "Kaydet"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* KİLO DIALOG */}
      <Dialog open={openKilo} onClose={() => !kiloLoading && setOpenKilo(false)} fullWidth maxWidth="sm">
        <DialogTitle>Canlı Ağırlık Ekle</DialogTitle>
        <DialogContent sx={{ pt: 2 }} style={{paddingTop:10}}>
          <Stack spacing={1}>
            {kiloError && <Alert severity="error">{kiloError}</Alert>}  
<TextField
  fullWidth
  size="medium"
  label="Veri Zaman"
  type="datetime-local"
  value={kiloForm.VERI_ZAMAN}
  onChange={(e) => setKiloForm({ ...kiloForm, VERI_ZAMAN: e.target.value })}
  InputLabelProps={{
    shrink: true,
    sx: { fontSize: 14 },
  }}
  InputProps={{
    sx: {
      fontSize: 16,
      "& .MuiInputBase-input": { py: 1.4 },
    },
  }}
/>
            <TextField
              label="Gram"
              value={kiloForm.GRAM}
              onChange={(e) => setKiloForm({ ...kiloForm, GRAM: e.target.value })}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenKilo(false)} disabled={kiloLoading}>Vazgeç</Button>
          <Button variant="contained" onClick={handleAddKilo} disabled={!canEdit || kiloLoading} sx={{ bgcolor: ORANGE }}
          startIcon={kiloLoading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
          >
            {kiloLoading ? "Kaydediliyor..." : "Kaydet"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ÖLÜM DIALOG */}
      <Dialog open={openOlum} onClose={() => !olumLoading && setOpenOlum(false)} fullWidth maxWidth="sm">
        <DialogTitle>Ölüm Ekle</DialogTitle>
        <DialogContent sx={{ pt: 2 }} style={{paddingTop:10}}>
          <Stack spacing={2}>
            {olumError && <Alert severity="error">{olumError}</Alert>}
            
            <TextField
              label="Ölüm Sayısı"
              type="number"
              value={olumForm.OLUM_SAYISI}
              onChange={(e) => setOlumForm({ ...olumForm, OLUM_SAYISI: e.target.value })}
               PaperProps={{
    sx: {
      height: "80vh",     
      maxHeight: "80vh",  
    },
  }}
            />
            <TextField
              label="Tarih"
              type="date"
              value={olumForm.TARIH}
              onChange={(e) => setOlumForm({ ...olumForm, TARIH: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Saat"
              type="time"
              value={olumForm.SAAT}
              onChange={(e) => setOlumForm({ ...olumForm, SAAT: e.target.value })}
              InputLabelProps={{ shrink: true }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenOlum(false)} disabled={olumLoading}>Vazgeç</Button>
          <Button variant="contained" onClick={handleAddOlum} disabled={!canEdit || olumLoading} sx={{ bgcolor: ORANGE }}
          startIcon={olumLoading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
          >
            {olumLoading ? "Kaydediliyor..." : "Kaydet"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* YEM DIALOG */}
      <Dialog open={openYem} onClose={() => !yemLoading2 && setOpenYem(false)} fullWidth maxWidth="sm">
        <DialogTitle>{isIntegrated ? "Yem İste" : "Yem Ekle"}</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Stack spacing={2}>
            {yemError && <Alert severity="error">{yemError}</Alert>} {/* ✅ HATA GÖSTER */}
            
{isIntegrated ? (
  <>
    <Box>
      <Typography sx={{ fontSize: 12, color: "#6B7280", mb: 0.5 }}>
        Yem Tipi
      </Typography>
      <Typography sx={{ fontWeight: 700 }}>
        {yemLoading ? "Yükleniyor..." : yemStokList[0]?.TANIM_YEM_TIP_ADI || "Veri yok"}
      </Typography>
    </Box>

    <TextField
    fullWidth
  size="medium"
      label="Sipariş Miktarı (kg)"
      type="number"
      value={yemForm.MIKTAR}
      onChange={(e) => setYemForm({ ...yemForm, MIKTAR: e.target.value })}
        InputLabelProps={{
    shrink: true,
    sx: { fontSize: 14 },
  }}
  InputProps={{
    sx: {
      fontSize: 16,
      "& .MuiInputBase-input": { py: 1.4 },
    },
  }}
  helperText="Otomatik: Şu anki tarih-saat (İsterseniz değiştirebilirsiniz)"
    />

    <FormControl fullWidth>
      <InputLabel>Acil</InputLabel>
      <Select
        value={yemForm.siparisAcil ? 1 : 0}
        label="Acil"
        onChange={(e) =>
          setYemForm({ ...yemForm, siparisAcil: Number(e.target.value) === 1 })
        }
      >
        <MenuItem value={0}>Normal</MenuItem>
        <MenuItem value={1}>Acil</MenuItem>
      </Select>
    </FormControl>
  </>
) : (
              <>
                <FormControl fullWidth>
                  <InputLabel>Yem Tipi</InputLabel>
                  <Select
                    value={yemForm.YEM_TIP_ID}
                    label="Yem Tipi"
                    onChange={(e) => setYemForm({ ...yemForm, YEM_TIP_ID: e.target.value })}
                  >
                    {yemTipleri.map((y) => (
                      <MenuItem key={y.YEM_TIP_ID} value={y.YEM_TIP_ID}>
                        {y.YEM_TIP_ADI}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel>Yem Fabrikası</InputLabel>
                  <Select
                    value={yemForm.YEM_FABRIKA_ID}
                    label="Yem Fabrikası"
                    onChange={(e) => setYemForm({ ...yemForm, YEM_FABRIKA_ID: e.target.value })}
                  >
                    {yemFabrikalar.map((f) => (
                      <MenuItem key={f.YEM_FABRIKA_ID} value={f.YEM_FABRIKA_ID}>
                        {f.YEM_FABRIKA_ADI}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>  

                <TextField
                  label="Açıklama"
                  value={yemForm.ACIKLAMA}
                  onChange={(e) => setYemForm({ ...yemForm, ACIKLAMA: e.target.value })}
                />
                <TextField
                  label="Birim Fiyat"
                  type="number"
                  value={yemForm.BIRIM_FIYAT}
                  onChange={(e) => setYemForm({ ...yemForm, BIRIM_FIYAT: e.target.value })}
                />
                <TextField
                  label="Miktar (kg)"
                  type="number"
                  value={yemForm.MIKTAR}
                  onChange={(e) => setYemForm({ ...yemForm, MIKTAR: e.target.value })}
                />
                <TextField
                  label="Tarih"
                  type="date"
                  value={yemForm.TARIH}
                  onChange={(e) => setYemForm({ ...yemForm, TARIH: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  label="Saat"
                  type="time"
                  value={yemForm.SAAT}
                  onChange={(e) => setYemForm({ ...yemForm, SAAT: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenYem(false)} disabled={yemLoading2}>Vazgeç</Button>
          <Button variant="contained" onClick={handleAddYem} disabled={!canEdit || yemLoading2} sx={{ bgcolor: ORANGE }}
          startIcon={yemLoading2 ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
          >
            {yemLoading2 ? (isIntegrated ? "İsteiliyor..." : "Kaydediliyor...") : (isIntegrated ? "İste" : "Kaydet")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ SU DÜZENLEME DIALOG */}
      <Dialog open={suEditOpen} onClose={() => !suEditLoading && setSuEditOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Su Verisini Düzenle</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Stack spacing={2}>
            <TextField
              label="Sayaç Değeri (m³)"
              type="number"
              value={suEditData?.SAYAC_DEGERI || ""}
              onChange={(e) =>
                setSuEditData({ ...suEditData, SAYAC_DEGERI: e.target.value })
              }
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSuEditOpen(false)} disabled={suEditLoading}>Vazgeç</Button>
          <Button variant="contained" onClick={handleUpdateSu} disabled={!canEdit || suEditLoading} sx={{ bgcolor: ORANGE }}
          startIcon={suEditLoading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
          >
            {suEditLoading ? "Kaydediliyor..." : "Kaydet"}
          </Button>
        </DialogActions>
      </Dialog>
            <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          severity={snack.severity}
          variant="filled"
          sx={{ fontWeight: 700, borderRadius: 3 }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}